/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_Item_04_AltInputs */

const en_elastic_gallery_item_04_alt = /** @type {(inputs: Elastic_Gallery_Item_04_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misty forest landscape`)
};

const ar_elastic_gallery_item_04_alt = /** @type {(inputs: Elastic_Gallery_Item_04_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منظر لغابة ضبابية`)
};

const bn_elastic_gallery_item_04_alt = /** @type {(inputs: Elastic_Gallery_Item_04_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কুয়াশাঘেরা বনের ল্যান্ডস্কেপ`)
};

const de_elastic_gallery_item_04_alt = /** @type {(inputs: Elastic_Gallery_Item_04_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebeliger Wald`)
};

const es_elastic_gallery_item_04_alt = /** @type {(inputs: Elastic_Gallery_Item_04_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paisaje de bosque brumoso`)
};

const fr_elastic_gallery_item_04_alt = /** @type {(inputs: Elastic_Gallery_Item_04_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paysage de forêt brumeuse`)
};

const pt_elastic_gallery_item_04_alt = /** @type {(inputs: Elastic_Gallery_Item_04_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paisagem de floresta enevoada`)
};

const zh_elastic_gallery_item_04_alt = /** @type {(inputs: Elastic_Gallery_Item_04_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`迷雾森林景观`)
};

const tr_elastic_gallery_item_04_alt = /** @type {(inputs: Elastic_Gallery_Item_04_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puslu orman manzarası`)
};

const ru_elastic_gallery_item_04_alt = /** @type {(inputs: Elastic_Gallery_Item_04_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Туманный лесной пейзаж`)
};

const pl_elastic_gallery_item_04_alt = /** @type {(inputs: Elastic_Gallery_Item_04_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mglisty krajobraz lasu`)
};

/**
* | output |
* | --- |
* | "Misty forest landscape" |
*
* @param {Elastic_Gallery_Item_04_AltInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_item_04_alt = /** @type {((inputs?: Elastic_Gallery_Item_04_AltInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_Item_04_AltInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_item_04_alt(inputs)
	if (locale === "bn") return bn_elastic_gallery_item_04_alt(inputs)
	if (locale === "de") return de_elastic_gallery_item_04_alt(inputs)
	if (locale === "es") return es_elastic_gallery_item_04_alt(inputs)
	if (locale === "fr") return fr_elastic_gallery_item_04_alt(inputs)
	if (locale === "pt") return pt_elastic_gallery_item_04_alt(inputs)
	if (locale === "zh") return zh_elastic_gallery_item_04_alt(inputs)
	if (locale === "tr") return tr_elastic_gallery_item_04_alt(inputs)
	if (locale === "ru") return ru_elastic_gallery_item_04_alt(inputs)
	if (locale === "pl") return pl_elastic_gallery_item_04_alt(inputs)
	return en_elastic_gallery_item_04_alt(inputs)
});